import { NgFor, NgIf, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { GalleryDto, TenantDto } from '@picflow/types';
import { MadeWithPicflowButtonComponent } from '../../../gallery-shared/components/made-with-picflow-button/made-with-picflow-button.component';
import { GalleryItemComponent } from '../../../shared-extra/components/gallery-item/gallery-item.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { TenantIconLoaderComponent } from '../../components/tenant-icon-loader/tenant-icon-loader.component';

@Component({
  selector: 'app-tenant-profile-page',
  templateUrl: './tenant-profile-page.component.html',
  styleUrls: ['./tenant-profile-page.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    ButtonDirective,
    TooltipDirective,
    SvgComponent,
    NgFor,
    RouterLink,
    GalleryItemComponent,
    MadeWithPicflowButtonComponent,
    TenantIconLoaderComponent,
  ],
})
export class TenantProfilePageComponent {
  tenant: TenantDto;
  galleries: GalleryDto[] = [];
  platformBrowser: boolean;

  constructor(private route: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: string) {
    this.tenant = this.route.snapshot.data.tenant;
    this.galleries = this.route.snapshot.data.galleries;
    this.platformBrowser = isPlatformBrowser(this.platformId);
  }

  niceSite(site: string) {
    if (!site) return '';
    if (site.split('//').length === 1) return site;
    return site.split('//')[1];
  }
}
